<template lang="pug" src="./custom-meet-slider.pug"></template>

<script>
import Arrow from 'templates/arrow.html'
import Title from 'components/block/block-title/block-title'

export default {
  data () {
    return {
      'arrow': Arrow
    }
  },
  props: ['props'],
  components: {
    Title
  }
}
</script>



// WEBPACK FOOTER //
// custom-meet-slider.vue?440afc64